import React, { FC } from "react";
import classes from "./Input.module.css";

interface IInputProps {
  label?: string;
  labelTxt?: string;
  type?: string;
  placeholder?: string;
  value?: string;
  required?: boolean;
  onChange?: () => void;
}

const Input: FC<IInputProps> = ({
  label,
  labelTxt,
  type,
  placeholder,
  value,
  required,
  onChange,
}) => {
  return (
    <div className={classes.Input}>
      <label htmlFor={label}>{labelTxt}</label>
      <input
        type={type}
        id={label}
        required={required}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default Input;
